module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.7016/img/business-types/hr-recruiting.png"